var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LinkedIn, Negative"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.2234 0.673828H1.77187C0.792187 0.673828 0 1.44727 0 2.40352V22.9395C0 23.8957 0.792187 24.6738 1.77187 24.6738H22.2234C23.2031 24.6738 24 23.8957 24 22.9441V2.40352C24 1.44727 23.2031 0.673828 22.2234 0.673828ZM7.12031 21.1254H3.55781V9.66914H7.12031V21.1254ZM5.33906 8.1082C4.19531 8.1082 3.27188 7.18477 3.27188 6.0457C3.27188 4.90664 4.19531 3.9832 5.33906 3.9832C6.47813 3.9832 7.40156 4.90664 7.40156 6.0457C7.40156 7.18008 6.47813 8.1082 5.33906 8.1082ZM20.4516 21.1254H16.8937V15.5566C16.8937 14.2301 16.8703 12.5191 15.0422 12.5191C13.1906 12.5191 12.9094 13.9676 12.9094 15.4629V21.1254H9.35625V9.66914H12.7687V11.2348H12.8156C13.2891 10.3348 14.4516 9.3832 16.1813 9.3832C19.7859 9.3832 20.4516 11.7551 20.4516 14.8395V21.1254Z",
    fill: "#FAFAFA",
    fillOpacity: 0.72
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.7627a41fafd706148a5872afb6005d68.svg";
export { ForwardRef as ReactComponent };